/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
export const UserColumnFormatter = (cellContent, row, rowIndex) => {
  const { User } = row;
  const { firstname = "", lastname = "" } = User || {};
  return (
    <>
      <div className="d-flex align-items-center text-dark text-capitalize">
        {`${firstname} ${lastname}`}
        {firstname.length === 0 && lastname.length === 0 && "-"}
      </div>
      <> </>
    </>
  );
};
